import Skeleton from '@pixum/skeleton';
import type { PickupPointSelectorProps } from '../../../types';
import styles from '../../../cartAddressStepSkeleton.module.css';

/** Displays the loading placeholder inside the pickup-point options area. */
export function PickupPointSkeleton({ constants }: Pick<PickupPointSelectorProps, 'constants'>) {
  return (
    <div aria-busy="true" aria-label={constants['i18n_pickup_point_options_loading']} role="status">
      {Array.from({ length: 4 }, (_, index) => (
        <div className={styles.pickupPointRow} key={index}>
          <Skeleton className={styles.pickupPointName} aria-hidden />
          <Skeleton className={styles.pickupPointAddress} aria-hidden />
        </div>
      ))}
    </div>
  );
}
